import { createFileRoute, redirect } from '@tanstack/react-router';
import { guardRoute } from '@/lib/route-guards';

/** `/me/salary` (FR-SAL-7, US-04): a deep link to the read-only Salary tab of my profile. */
export const Route = createFileRoute('/_app/me_/salary')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/me');
    throw redirect({ to: '/me', search: { tab: 'salary' }, replace: true });
  },
});
